module.exports = __webpack_public_path__ + "img/recorded_camera_select_button.e20f3cc0.svg";